import {
  Component,
  ViewEncapsulation,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { ControlCrane } from "../../services/controlCrane.service";
import { Router } from "@angular/router";
import { AppStateService } from "../../services/appState.service";

import { ControlAllgemeinComponent } from "../craneControlAllgemein/controlAllgemein.component";

import * as allgemeineFunktionen from "../../allgemeinesTS_CSS/allgemeineHilfsfunktionen";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "app-crane-control",
  templateUrl: "./control360.component.html",
  styleUrls: [
    "./control360.component.css",
    "../craneControlAllgemein/controlAllgemein.component.css",
    "../craneSetup/egrid.css",
    "../../allgemeinesTS_CSS/tooltip.css",
    "../../allgemeinesTS_CSS/cssButton.css",
  ],
  providers: [ControlCrane],
  encapsulation: ViewEncapsulation.None,
})
export class Control360Component
  extends ControlAllgemeinComponent
  implements OnInit, OnDestroy
{
  @ViewChild("HIWinkelInput") formHIWinkelInput: ElementRef;
  @ViewChild("LastTabelle") LastTabelle: any;
  public gridData: Object[] = [];
  private rlhTabelleAktualisieren = false;
  protected AbstuetzungHintenEng = false;
  // Einstellungen für Darstellung der Tabelle
  public filterType: any;
  public tabellenEinstellungen: object[] = [];
  private updater;
  constructor(
    private craneControlService: ControlCrane,
    private router: Router,
    private appStateService: AppStateService,
    sanitizer: DomSanitizer
  ) {
    super(craneControlService, router, appStateService, sanitizer);
  }
  ngOnInit() {
    this.tabellenEinstellungen["selectionMode"] = { selectionMode: ["row"] };
    this.tabellenEinstellungen["pageSettings"] = { pageSize: 20 };
    this.appStateService.appStatusVonServerHolen().then((res) => {
      if (res["loginStatus"] !== "loggedIn") {
        this.router.navigate(["/"]);
      }
      this.gewichtsEinheit = this.appStateService.holeEinheitenSystem("G");
      this.laengenEinheit = this.appStateService.holeEinheitenSystem("L");
      // Im Status setze ich die Einheiten ebenfalls, damit wir auf Server Seite auch wissen wie wir unterwegs sind.
      this.appStateService.appStatusSetzen({
        aktuellerMenuePunkt: "CraneControl",
        PrintOut: "active",
        gewichtsEinheit: this.gewichtsEinheit,
        laengenEinheit: this.laengenEinheit,
      });
      this.initComponent();
    });
  }
  ngOnDestroy() {
    clearInterval(this.updater);
  }

  holeInitialeDaten() {
    if (this.aendereWerte["holeInitialeDaten"] !== undefined) {
      clearTimeout(this.aendereWerte["holeInitialeDaten"]);
    }
    this.aendereWerte["holeInitialeDaten"] = setTimeout(() => {
      if (this.lastGesetzt === true) {
        this.aktualisiereAnzeige = true;
        this.craneControlService.minMAXan(true).then(() => {
          this.holeRuestdaten();
          this.holeErgebnisse();
          this.holeRLHTabelle();
          this.holeMAXWerte();
          this.updater = setInterval(() => this.tabellenZeileMarkieren(), 1000);
          this.aktualisiereAnzeige = false;
          this.initialisiereKran = false;
          super.holeInitialeDaten();
        });
      } else {
        this.holeInitialeDaten();
      }
    }, 200);
  }
  holeRLHTabelle() {
    this.rlhTabelleAktualisieren = true;
    this.craneControlService
      .holeRLHTabelle()
      .then((res) => this.befuelleRLHTabelle(res));
  }
  befuelleRLHTabelle(tabelle) {
    this.gridData = [];
    for (const zeile of tabelle) {
      this.gridData.push(zeile);
    }
    this.ladeKran = false;
    this.rlhTabelleAktualisieren = false;
  }
  einlesenRuestdaten(res) {
    super.einlesenRuestdaten(res); // Werte für Abstützungen setzen
    let abstuetzung: string;
    if (res["Abstuetzung"] === "OnWheels") {
      abstuetzung = "x0";
    } else {
      abstuetzung = res["Abstuetzung"].substring(
        res["Abstuetzung"].indexOf("x") + 1,
        res["Abstuetzung"].indexOf(this.laengenEinheit)
      );
      if (abstuetzung.indexOf("/") > -1) {
        abstuetzung = "-" + abstuetzung.substring(0, abstuetzung.indexOf("/"));
        // erzeuge einen passenden Eintrag in der AbtuetzProzenteListe
        const newObject = {
          ID:
            "x-" +
            res["AbstuetzProzente"][res["AbstuetzProzente"].length - 1][
              "ID"
            ].substr(1),
          Prozent:
            res["AbstuetzProzente"][res["AbstuetzProzente"].length - 1][
              "Prozent"
            ],
          Weite:
            res["AbstuetzProzente"][res["AbstuetzProzente"].length - 1][
              "Weite"
            ],
          StuetzenPosition:
            res["AbstuetzProzente"][res["AbstuetzProzente"].length - 1][
              "StuetzenPosition"
            ],
        };
        res["AbstuetzProzente"].push(newObject);
      }
      abstuetzung = "x" + String(parseFloat(abstuetzung));
    }
    if (allgemeineFunktionen.isset(res["AbstuetzProzente"])) {
      // abstuetzungProzent aufbauen
      res["AbstuetzProzente"].forEach((element) => {
        this.abstuetzungProzent[element["ID"]] = {
          Prozent: element["Prozent"],
          Weite: element["Weite"],
          StuetzenPosition: element["StuetzenPosition"],
        };
      });
      // Prozentwerte für Abstuetzung setzen;
      this.abstuetzungProzent["stuetzeVL"] =
        this.abstuetzungProzent[abstuetzung]["Prozent"];
      this.abstuetzungProzent["stuetzeVR"] =
        this.abstuetzungProzent[abstuetzung]["Prozent"];
      if (res["Abstuetzung"].indexOf("/") > -1) {
        // asymmetrisch
        this.abstuetzungProzent["stuetzeHL"] = "0";
        this.abstuetzungProzent["stuetzeHR"] = "0";
        this.AbstuetzungHintenEng = true;
      } else {
        this.abstuetzungProzent["stuetzeHL"] =
          this.abstuetzungProzent[abstuetzung]["Prozent"];
        this.abstuetzungProzent["stuetzeHR"] =
          this.abstuetzungProzent[abstuetzung]["Prozent"];
        this.AbstuetzungHintenEng = true;
      }
      // Grafik für Stützen setzen
      const maxStuetzenPosition: string =
        res["AbstuetzProzente"][res["AbstuetzProzente"].length - 1][
          "StuetzenPosition"
        ];
      if (res["Abstuetzung"].indexOf("/") > -1) {
        this.stuetzeHR =
          "url(" +
          this.grafikBasis +
          "Stuetzen_L_" +
          "1" +
          "-" +
          (parseFloat(maxStuetzenPosition) + 1).toString() +
          ".png)";
        this.stuetzeHL =
          "url(" +
          this.grafikBasis +
          "Stuetzen_R_" +
          "1" +
          "-" +
          (parseFloat(maxStuetzenPosition) + 1).toString() +
          ".png)";
      } else {
        this.stuetzeHR =
          "url(" +
          this.grafikBasis +
          "Stuetzen_L_" +
          this.abstuetzungProzent[abstuetzung]["StuetzenPosition"] +
          "-" +
          maxStuetzenPosition +
          ".png)";
        this.stuetzeHL =
          "url(" +
          this.grafikBasis +
          "Stuetzen_R_" +
          this.abstuetzungProzent[abstuetzung]["StuetzenPosition"] +
          "-" +
          maxStuetzenPosition +
          ".png)";
      }
      this.stuetzeVR =
        "url(" +
        this.grafikBasis +
        "Stuetzen_L_" +
        this.abstuetzungProzent[abstuetzung]["StuetzenPosition"] +
        "-" +
        maxStuetzenPosition +
        ".png)";
      this.stuetzeVL =
        "url(" +
        this.grafikBasis +
        "Stuetzen_R_" +
        this.abstuetzungProzent[abstuetzung]["StuetzenPosition"] +
        "-" +
        maxStuetzenPosition +
        ".png)";
      // Stuetzeninfos in Status und auf Server speichern
      this.appStateService.appStatusSetzen({
        abstuetzProzenteVL: this.abstuetzungProzent[abstuetzung]["Prozent"],
        abstuetzProzenteVR: this.abstuetzungProzent[abstuetzung]["Prozent"],
        abstuetzProzenteHL: this.abstuetzungProzent[abstuetzung]["Prozent"],
        abstuetzProzenteHR: this.abstuetzungProzent[abstuetzung]["Prozent"],
        maxStuetzenPosition: maxStuetzenPosition,
        stuetzenPositionVL:
          this.abstuetzungProzent[abstuetzung]["StuetzenPosition"],
      });
    }
  }
  hiWinkelAendern(neuerWinkel: string) {
    if (this.aendereWerte["hiWinkelAendern"] !== undefined) {
      clearTimeout(this.aendereWerte["hiWinkelAendern"]);
    }
    neuerWinkel = allgemeineFunktionen.kommaInPunkt(neuerWinkel);
    if (isNaN(Number(neuerWinkel))) {
      this.zeigeFehler(
        "Incorrect value",
        "The value entered is not at number, please enter a number value.",
        () => {
          this.formHIWinkelInput.nativeElement.value = this.hi1Winkel;
        }
      );
    } else {
      if (this.hiFeldTyp == "HI_frei") {
        // Winkel auf Cranebee System anpassen.
        // Wir haben in diesem Fall die Winkel zwischen Horizontaler und HI.
        // Grove möchte aber den Winkel zwischen HA - Verlängerung und HI
        neuerWinkel = allgemeineFunktionen.kommaInPunkt(
          (+this.HAWinkel - +neuerWinkel).toString()
        );
      }
      this.aendereWerte["hiWinkelAendern"] = setTimeout(() => {
        if (neuerWinkel === "") {
          neuerWinkel = String(this.hi1Winkel);
          this.SetHi1Winkel(neuerWinkel);
        }
        if (neuerWinkel !== String(this.hi1Winkel)) {
          this.aktualisiereAnzeige = true;
          this.craneControlService.aendereHi1Winkel(neuerWinkel).then((res) => {
            if (res["hi1WinkelGesetzt"] === false) {
              this.zeigeFehler(
                "Angle not possible",
                "The angle you choose is not possible for this configuration.\nSettings will be reset.",
                () => {
                  this.SetHi1Winkel(String(res["HI1Winkel"]));
                }
              );
            }
            this.appStateService.appStatusSetzen({
              pointer: res["Pointer"],
            });
            this.aktualisiereAnzeigeFelder(res);
            this.holeRLHTabelle();
            this.holeMAXWerte();
            this.pruefeAufKompatiblenTabellenKran();
          });
        }
      }, 100);
    }
  }

  SetHi1Winkel(hiWinkel: string) {
    if (this.hiFeldTyp == "HI_frei") {
      this.hi1Winkel = allgemeineFunktionen.kommaInPunkt(
        (+this.HAWinkel - +hiWinkel).toFixed(2).toString()
      );
    } else {
      this.hi1Winkel = hiWinkel;
    }
  }

  haLaengeAendernAusfuehren(): Promise<any> {
    return super.haLaengeAendernAusfuehren().then(() => {
      this.holeRLHTabelle();
      this.holeMAXWerte();
    });
  }
  rowSelected() {}
  bitteWarten() {
    return super.bitteWarten() || this.rlhTabelleAktualisieren;
  }
  tabellenZeileMarkieren() {
    const tabelle = this.LastTabelle.widget;
    if (
      this.Radius === undefined ||
      this.Radius === null ||
      this.gridData === undefined ||
      this.gridData === null ||
      this.gridData.length === 0 ||
      this.laengenEinheit === undefined ||
      this.laengenEinheit === null
    ) {
      return;
    }
    let i = 0;
    while (i < tabelle.model.currentViewData.length) {
      if (
        parseFloat(
          tabelle.model.currentViewData[i].Radius.substring(
            0,
            tabelle.model.currentViewData[i].Radius.length -
              this.laengenEinheit.length
          )
        ) > parseFloat(this.Radius)
      ) {
        if (
          i > 0 &&
          parseFloat(
            tabelle.model.currentViewData[i - 1].Radius.substring(
              0,
              tabelle.model.currentViewData[i - 1].Radius.length -
                this.laengenEinheit.length
            )
          ) === parseFloat(this.Radius)
        ) {
          i--;
        }
        break;
      }
      i++;
    }
    tabelle.selectRows(Math.min(i, tabelle.model.currentViewData.length - 1));
  }
}
